/*
 * @Description:
 * @Author: HG
 * @Date: 2019-08-21 13:38:08
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-03-15 14:04:22
 */
import Vue from "vue";
import Component from "./SelectPicker.vue";

const Constructor = Vue.extend(Component);

// const instances = [];
let seed = 1;

const SelectPicker = options => {
  if (Vue.prototype.$isServer) return;

  const {
    //autoClose,
    ...rest
  } = options;
  const instance = new Constructor({
    propsData: {
      ...rest,
    },
    data: {
      //autoClose: autoClose === undefined ? 3000 : autoClose
    },
  });

  const id = `SelectPicker_${seed++}`;
  instance.id = id;
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.visible = true;

  //绑定 change 方法
  instance.vm.$on("change", selecteds => {
    console.log(selecteds);
    if (instance.change) {
      instance.change(selecteds);
    }
  });
  instance.vm.$on("destroy", () => {
    document.body.removeChild(instance.vm.$el);
  });
  return instance.vm;
};

export default SelectPicker;
